import React, { FC } from 'react';
import { useRouteMatch, Route } from 'react-router-dom';
import { PrivateRoute } from 'routes/PrivateRoute';
import { ProductList } from 'features/Products/ProductList';
import { ProductDetails } from 'features/ProductDetails/ProductDetails';
import { ProductDocuments } from 'features/ProductDetails/ProductDocuments';
import { ProductSites } from 'features/ProductDetails/ProductSites';
import { ProductSerialNumbers } from 'features/ProductDetails/ProductSerialNumbers';
import { ProductComponents } from 'features/ProductDetails/ProductComponents';
import { ProductFormWrapper } from 'features/ProductDetails/ProductFormWrapper';
import { productsDetails, profilePrefix } from 'routes/routes';
import { ProductsNavBar } from 'components/NavBar/ProductsNavBar';
import {
  COMPONENTS,
  DETAILS,
  DOCUMENTS,
  PRODUCTION,
  PROPERTIES,
  SERIAL_NUMBERS
} from 'components/NavBar/productFormTabs';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { ProductProperties } from 'features/ProductDetails/ProductProperties';
import { SwitchCatchNotFound as Switch } from './SwitchCatchNotFound';
import { ManageCompanyRedirects } from './ManageCompanyRedirects';

const ProductsRoutes: FC<{}> = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <AppMenuDrawer />
      <ManageCompanyRedirects redirectTo={profilePrefix} />
      <Switch>
        <PrivateRoute exact path={path} component={ProductList} navbar={ProductsNavBar} />
        <PrivateRoute exact path={`${path}/new`} component={ProductDetails} navbar={ProductsNavBar} />
        <Route path={`${path}${productsDetails}/*`}>
          <ProductFormWrapper>
            <Switch>
              <PrivateRoute
                path={`${path}${productsDetails}/${DETAILS}`}
                component={ProductDetails}
                navbar={ProductsNavBar}
              />
              <PrivateRoute
                path={`${path}${productsDetails}/${PROPERTIES}`}
                component={ProductProperties}
                navbar={ProductsNavBar}
              />
              <PrivateRoute
                path={`${path}${productsDetails}/${DOCUMENTS}`}
                component={ProductDocuments}
                navbar={ProductsNavBar}
              />
              {/*<PrivateRoute
                path={`${path}${productsDetails}/${PRODUCTION}`}
                component={ProductSites}
                navbar={ProductsNavBar}
              />*/}
              <PrivateRoute
                path={`${path}${productsDetails}/${SERIAL_NUMBERS}`}
                component={ProductSerialNumbers}
                navbar={ProductsNavBar}
              />
              {/* <PrivateRoute
                path={`${path}${productsDetails}/${COMPONENTS}`}
                component={ProductComponents}
                navbar={ProductsNavBar}
              /> */}
            </Switch>
          </ProductFormWrapper>
        </Route>
      </Switch>
    </>
  );
};

export { ProductsRoutes };
